<template>
<div>
    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        <router-link to="/dashboard" class="text-white pl-3">
            <i class="ni ni-tv-2"></i> Dashborad
        </router-link><i class="ni ni-bold-right text-white"></i>     
        <span class="text-white"><i class="ni ni-bold-right"></i>Church</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
        <card header-classes="bg-transparent">
            <div v-if="openform">
                <div class="card bg-secondary border-0 mb-0">
                    <div class="card-body">
                        <div class="form-horizontal">
                            <form role="form" @submit.prevent="submitdata">
                                <div class="card bg-gradient-success">
                                    <h5 class="card-header">Church Details</h5>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12 pb-2">
                                                <img v-if="uploadedimage" height="100" :src="uploadedimage">
                                                <img v-else height="100" src="img/brand/empty.png"><br>                                 

                                                <input type="file" id="file" ref="file" class="inputfile inputfile-1" v-on:change="handleFileUpload()">                                               
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label class="text-white">Church Name</label>
                                                    <input v-model="ChurchNameval" class="form-control" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Short Name</label>
                                                    <input v-model="ShortNameval" class="form-control" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Email Address</label>
                                                    <input v-model="EmailAddressval" type="email" class="form-control" required>
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Phone Number</label>
                                                    <input v-model="PhoneNumberval" type="phone" class="form-control" required>
                                                </div>
                                            </div>
                                             <div class="col-md-12">
                                                <div class="form-group">
                                                    <label class="text-white">Address</label>
                                                   <vue-google-autocomplete
                                                        ref="address"
                                                        id="map"
                                                        classname="form-control"
                                                        placeholder="Please type the address"
                                                        v-on:placechanged="getAddressData"
                                                        class="form-control"
                                                    >
                                                    </vue-google-autocomplete>
                                                                                                       
                                                      <input type="hidden" v-model="GoogleAddressval" />
                                                       <input type="hidden" v-model="Longitudeval" />
                                                        <input type="hidden" v-model="Latitudeval" />
                                                </div>
                                            </div>  
                                             <div class="col-md-12">
                                                <div class="form-group">
                                                    <label class="text-white">Address Description</label>
                                                    <textarea v-model="AddressDescriptionval" class="form-control" rows="2" required></textarea>
                                                   
                                                </div>
                                            </div>   
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Web Address</label>
                                                    <input v-model="WebAddressval" class="form-control" required>
                                                </div>
                                            </div> 
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Portal Web Address</label>
                                                    <input v-model="PortalWebAddressval" class="form-control" required>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="card bg-gradient-success">
                                    <h5 class=" card-header">Contact Person Details</h5>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Contact Person First Name</label>
                                                    <input v-model="ContactPersonFirstNameval" class="form-control" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Contact Person Middle Name</label>
                                                    <input v-model="ContactPersonMiddleNameval" class="form-control">
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Contact Person Last Name</label>
                                                    <input v-model="ContactPersonLastNameval" class="form-control" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Contact Person Email</label>
                                                    <input v-model="ContactEmailAddressval" class="form-control" type="email" required>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Contact Person Phone Number</label>
                                                    <input v-model="ContactPhoneNumberval" type="phone" class="form-control" required>
                                                </div>
                                            </div>  
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">Contact Person Sex</label>
                                                     <select v-model="ContactPersonSexval" class="form-control">
                                                        <option value="0"></option>
                                                        <option v-for="item in sex" :key="item" :value="item">{{item}} </option>                                                                                                            
                                                    </select>
                                                </div>
                                            </div>   
                                                                                  
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="card bg-gradient-success">
                                    <h5 class=" card-header">Email Setup</h5>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">From Email</label>
                                                    <input v-model="FromEmailval" type="email" class="form-control" required>
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">SMTP Client</label>
                                                    <input v-model="SMTPClientval" class="form-control" required>
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">SMTP Username</label>
                                                    <input v-model="SMTPUsernameval" class="form-control" required>
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="text-white">SMTP Password</label>
                                                    <input v-model="SMTPPasswordval" class="form-control" required>
                                                </div>
                                            </div>                                           
                                        </div>
                                    </div>
                                </div>                               
                                <hr>
                                <div class="text-center mb-3">
                                    <button type="button" @click.stop="closeform()" class="btn btn-secondary">Cancel</button>
                                    <button type="submit" class="btn btn-primary my-4">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="form-inline">
                    <button type="button" @click.prevent="newterm" class="btn btn-default"><i class="ni ni-fat-add"></i>Add New </button>
                    <div class=" input-group">
                        <input v-model="searchval" class="form-control" @keyup="getsearch" placeholder="Search...">
                        <div class=" input-group-append">
                            <button type="button" @click.prevent="getsearch" class="btn btn-secondary"><i class="fa fa-search"></i> Search </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3" v-for="item in resultitems" :key="item.Id">
                        <div class="card bg-translucent-success shrink my-3">
                            <div class="card-body text-center">
                                <img v-if="item.ChurchLogo" :src="$store.state.auth.baseurl + item.ChurchLogo.substr(1)" class=" rounded-circle" alt="" height="60">
                                <img v-else src="img/brand/empty.png" class="rounded-circle" alt="" height="60" />
                                <h5 class="text-white mt-2">{{ item.ChurchName }}</h5>
                                <h6 class="text-white">{{ item.EmailAddress }}</h6>
                                <h6 class="text-white">{{ item.PhoneNumber }}</h6>                                
                                <div class=" card-footer">
                                    <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item.Id)"><i class="fa fa-edit"></i> Edit</button>                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    </div>
</div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {
    mapState
} from 'vuex'
export default {
    components: { VueGoogleAutocomplete },
    name: 'church',
    data() {
        return {
            Idval: 1,
            address:'',
            ChurchNameval: '',
            ShortNameval: '',
            EmailAddressval: '',
            PhoneNumberval: '',
            ContactPersonFirstNameval: '',
            ContactPersonMiddleNameval:'',
            ContactPersonLastNameval:'',
            ContactPhoneNumberval: '',
            ContactEmailAddressval: '',
            ContactPersonSexval:'',
            GoogleAddressval:'',
            Longitudeval:'',
            Latitudeval:'',
            WebAddressval: '',
            PortalWebAddressval: '',
            FromEmailval: '',
            SMTPClientval: '',
            SMTPUsernameval: '',
            SMTPPasswordval: '',
            AddressDescriptionval: '',
            ChurchLogoval: '', 
            resultitems:null,          
            file: '',
            uploadedimage: '',
            searchval: '',
            process: 'N',
            openform: false,           
            onloader: 'none'
        }
    }, 
    computed: {
        ...mapState({
            sex: state => state.appdata.sex
        })
    },
    methods: {
        newterm: function () {
            this.ChurchNameval= '';
            this.ShortNameval= '';
            this.EmailAddressval= '';
            this.PhoneNumberval='';
            this.ContactPersonFirstNameval= '';
            this.ContactPersonMiddleNameval='';
            this.ContactPersonLastNameval='';
            this.ContactPersonSexval='';
            this.ContactPhoneNumberval= '';
            this.ContactEmailAddressval= '';
            this.WebAddressval= '';
            this.PortalWebAddressval= '';
            this.FromEmailval='';
            this.SMTPClientval= '';
            this.SMTPUsernameval= '';
            this.SMTPPasswordval= '';
            this.AddressDescriptionval= '';
            this.ChurchLogoval= '';          
            this.file = '';
            this.uploadedimage = '';           
            this.openform = true;
            this.process = 'N';            
        },
        closeform: function () {
            this.ChurchNameval= '';
            this.ShortNameval= '';
            this.EmailAddressval= '';
            this.PhoneNumberval='';
            this.ContactPersonFirstNameval= '';
            this.ContactPersonMiddleNameval='';
            this.ContactPersonLastNameval='';
            this.ContactPersonSexval='';
            this.ContactPhoneNumberval= '';
            this.ContactEmailAddressval= '';
            this.WebAddressval= '';
            this.PortalWebAddressval= '';
            this.FromEmailval='';
            this.SMTPClientval= '';
            this.SMTPUsernameval= '';
            this.SMTPPasswordval= '';
            this.AddressDescriptionval= '';
            this.ChurchLogoval= ''; 
            this.file = '';
            this.uploadedimage = '';
            this.openform = false;
            this.process = 'N';
            this.inputdisable = false;
        },   
        getAddressData: function (addressData, placeResultData, id) {
           // this.address  = addressData;
           this.Longitudeval=addressData.longitude;
           this.Latitudeval=addressData.latitude;
           this.GoogleAddressval=placeResultData.formatted_address;
           console.log(id);

        },    
        edititem: function (Id) {
            this.onloader = 'flex'
            this.$store.dispatch('getchurchbyid', Id)
                .then(resp => {                   
                    this.Idval = resp.Id;
                    if (resp.ChurchLogo != null) {
                        this.uploadedimage = this.$store.state.auth.baseurl + resp.ChurchLogo.substr(1);
                    }
                    this.ChurchLogoval = resp.ChurchLogo;
                    this.ChurchNameval= resp.ChurchName;
                    this.ShortNameval= resp.ShortName;
                    this.EmailAddressval= resp.EmailAddress;
                    this.PhoneNumberval=resp.PhoneNumber;
                    this.GoogleAddressval=resp.GoogleAddress;
                    this.Longitudeval=resp.Longitude;
                    this.Latitudeval=resp.Latitude;
                    this.ContactPersonFirstNameval= resp.FirstName;
                    this.ContactPersonMiddleNameval=resp.MiddleName;
                    this.ContactPersonLastNameval=resp.LastName;
                    this.ContactPersonSexval=resp.Sex.trim();
                    this.ContactPhoneNumberval= resp.ContactPersonPhoneNo;
                    this.ContactEmailAddressval= resp.ContactPersonEmail;
                    this.WebAddressval= resp.WebAddress;
                    this.PortalWebAddressval= resp.PortalWeAddress;
                    this.FromEmailval=resp.FromEmail;
                    this.SMTPClientval= resp.SMTPClient;
                    this.SMTPUsernameval= resp.SMTPUsername;
                    this.SMTPPasswordval= resp.SMTPPassword;
                    this.AddressDescriptionval= resp.AddressDescription;                   
                    this.openform = true;
                    this.process = 'U';
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },     
        submitdata: function () {
            let Id = this.Idval;
            let ChurchLogo = this.ChurchLogoval;
            let ChurchName =  this.ChurchNameval;
            let ShortName =  this.ShortNameval;
            let EmailAddress = this.EmailAddressval;
            let PhoneNumber = this.PhoneNumberval;
            let GoogleAddress=this.GoogleAddressval;
            let Longitude=this.Longitudeval;
            let Latitude=this.Latitudeval;
            let ContactPersonFirstName= this.ContactPersonFirstNameval;
            let ContactPersonMiddleName= this.ContactPersonMiddleNameval;
            let ContactPersonLastName= this.ContactPersonLastNameval;
            let ContactPersonSex =  this.ContactPersonSexval;
            let ContactPhoneNumber= this.ContactPhoneNumberval;
            let ContactEmailAddress = this.ContactEmailAddressval;
            let WebAddress = this.WebAddressval;
            let PortalWebAddress = this.PortalWebAddressval;
            let FromEmail =  this.FromEmailval;
            let SMTPClient = this.SMTPClientval;
            let SMTPUsername = this.SMTPUsernameval;
            let SMTPPassword = this.SMTPPasswordval;
            let AddressDescription = this.AddressDescriptionval;
            let Operation = this.process;
            let Username = this.$store.state.auth.token;         
            this.onloader = 'flex';
            let userdata={Id, ChurchLogo, ChurchName, ShortName, EmailAddress, PhoneNumber,GoogleAddress,Longitude,Latitude, ContactPersonFirstName, ContactPersonMiddleName, ContactPersonLastName, ContactPersonSex, ContactPhoneNumber, ContactEmailAddress, WebAddress, PortalWebAddress, FromEmail, SMTPClient, SMTPUsername, SMTPPassword, AddressDescription, Operation, Username}           
            this.$store.dispatch('processchurch', userdata)
                .then((resp) => {
                    this.resultitems = resp;
                    this.closeform();
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: 'Submitted successfully',
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getchurch: function () {
            this.onloader = 'flex'
            this.$store.dispatch('getchurch')
                .then((resp) => {
                    this.resultitems = resp;
                    this.onloader = 'none'
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getsearch: function () {
            this.$store.dispatch('getchurchbysearch', this.searchval)
                .then((resp) => {
                    this.resultitems = resp;
                    //console.log(resp)
                })
                .catch(err => {
                    this.checkresponse(err.response.data);
                })
        },       

        handleFileUpload: function () {
            this.file = this.$refs.file.files[0];
            this.submitFile();
        },
        submitFile: function () {
            this.onloader = 'flex'
            var form = new FormData();
            let username = this.$store.state.auth.token;          
            let formalurl = this.Passportval;
            let doctype = 'image';
            form.append('username', username)          
            form.append('formalurl', formalurl)
            form.append('doctype', doctype)
            form.append('file', this.file)
            this.$store.dispatch('uploadfile', form)
                .then((resp) => {
                    this.ChurchLogoval = resp;
                    this.uploadedimage = this.$store.state.auth.baseurl + resp.substr(1)
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: 'Uploaded successfully',
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        frontEndDateFormat: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
        backEndDateFormat: function (date) {
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        },
        checkresponse: function (resp) {
            if (resp === "Access Expired" || resp === "Invalid Credential") {
                this.$store.dispatch('logout');
                this.$router.push('/login')
            } else {
                console.log(resp);
            }
        }

    },
    mounted() {
        if (this.$store.state.auth.user_status_id != 1) {
            this.$store.dispatch('logout')
            this.$router.push('/login')
        } else { 
               
            this.getchurch();
        }

    }
};
</script>

<style>

</style>
